// @flow
import { TypesContactsActionTypes } from './constants';

type TypesContactsAction = { type: string, payload: {} | string };

// common success
export const typesContactsApiResponseSuccess = (actionType: string, data: any): TypesContactsAction => ({
    type: TypesContactsActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const typesContactsApiResponseError = (actionType: string, error: string): TypesContactsAction => ({
    type: TypesContactsActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getTypeContact = (id: string): TypesContactsAction => ({
    type: TypesContactsActionTypes.GET_TYPES_CONTACTS,
    payload: { id },
});

export const addTypesContact = (typeContacto:any):TypesContactsAction=>({
    type:TypesContactsActionTypes.ADD_TYPES_CONTACTS,
    payload:typeContacto
})
export const updateTypesContact = (typeContacto:any):TypesContactsAction=>({
    type:TypesContactsActionTypes.UPDATE_TYPES_CONTACTS,
    payload:typeContacto
})
export const deleteTypesContact = (id:string):TypesContactsAction=>({
    type:TypesContactsActionTypes.DELETE_TYPES_CONTACTS,
    payload:{id}
})

export const listTypesContacts = (params:any): TypesContactsAction => ({
    type: TypesContactsActionTypes.LIST_TYPES_CONTACTS,
    payload: params,
});


export const resetTypesContacts = (): TypesContactsAction => ({
    type: TypesContactsActionTypes.RESET,
    payload: {},
});

